module.exports = __webpack_public_path__ + "static/media/android.4dd758f5.jpg";